<template>
  <mdb-container>
    <EditGiftCard :default-marker="marker" />
  </mdb-container>
</template>

<script>
import { mdbContainer } from "mdbvue";
import EditGiftCard from "@/components/EditGiftCard.vue";

export default {
  name: "AddGiftCard",
  components: {
    mdbContainer,
    EditGiftCard
  },
  data() {
    return {
      marker: {
        name: "Helsinki",
        position: { lat: 60.1733244, lng: 24.9410248 },
        radius: 0
      }
    };
  }
};
</script>

<style></style>
